import { render, staticRenderFns } from "./region.vue?vue&type=template&id=5da6161b&scoped=true&"
import script from "./region.vue?vue&type=script&lang=ts&"
export * from "./region.vue?vue&type=script&lang=ts&"
import style0 from "./region.vue?vue&type=style&index=0&id=5da6161b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da6161b",
  null
  
)

export default component.exports